import React from 'react';
import { useNamespaceTranslations } from './useNamespaceTranslations';
export const createTranslationsProvider = _ref => {
  let {
    providerName,
    namespace = 'translation'
  } = _ref;
  const TranslationsContext = /*#__PURE__*/React.createContext({});
  const TranslationsProvider = _ref2 => {
    let {
      children,
      ...props
    } = _ref2;
    const {
      i18n,
      t,
      Trans,
      locale
    } = useNamespaceTranslations({
      i18n: props.i18n,
      resources: props.resources,
      namespace,
      Trans: props.Trans
    });
    return /*#__PURE__*/React.createElement(React.Suspense, {
      fallback: "loading..."
    }, /*#__PURE__*/React.createElement(TranslationsContext.Provider, {
      value: {
        translationService: {
          i18n,
          locale,
          t,
          Trans
        }
      }
    }, children));
  };
  const useTranslations = () => {
    const {
      translationService
    } = React.useContext(TranslationsContext);
    if (!translationService) {
      throw new Error(`${providerName} was not initialized, add <${providerName}/> to your app root`);
    }
    return {
      ...translationService
    };
  };
  return {
    TranslationsProvider,
    useTranslations
  };
};
//# sourceMappingURL=createTranslationsProvider.js.map